import React, { Component } from "react"
import Avatar from "./avatar"
import DropdownButton from "react-bootstrap/lib/DropdownButton"
import MenuItem from "react-bootstrap/lib/MenuItem"
import Circle from "../images/circle-minus.svg"
import { toTitleCase } from "../util/name_utils"
import { makeToast } from "../util/toast_util"
import { getDisplayName } from "../util/name_utils"
import Archive from "../images/archive-icon.svg"
import { appStrings } from "../common/strings/app_strings"

const {
    disableMemberMsg,
    deleteInviteMsg,
    warning: ind,
    accessLevelOwnMembershipMsg,
    accessLevelIsTeamOwnerMsg,
} = appStrings.teamEditModal

class TeamMemberRow extends Component {
    constructor(props) {
        super(props)

        this.viewReport = this.viewReport.bind(this)
    }

    viewReport() {
        const { teamMember, reportUser } = this.props
        reportUser(teamMember.primaryEmail)
    }

    handleDisableMember = () => {
        const { teamMember, onDisable } = this.props
        const { id } = teamMember

        onDisable(id)
    }

    handleDeleteInvite = () => {
        const { teamMember, deleteInvite } = this.props
        const { id } = teamMember

        deleteInvite(id)
    }

    handleAdminAction = () => {
        const { isInvitedMember } = this.props
        const toastMsg = isInvitedMember ? deleteInviteMsg : disableMemberMsg
        const adminAction = isInvitedMember
            ? this.handleDeleteInvite
            : this.handleDisableMember
        const action = {
            text: "YES",
            onClick: adminAction,
        }
        makeToast(toastMsg, ind, action)
    }
    
    updateRole = role => {
        const {
            teamMember,
            updateMemberRole,
            canEditMembership,
            isCurrentUser,
            isTeamOwner,
        } = this.props

        if (isCurrentUser) {
            makeToast(accessLevelOwnMembershipMsg, ind)
            return
        }

        if (isTeamOwner) {
            makeToast(
                `${teamMember.fullName ||
                    "This member"} ${accessLevelIsTeamOwnerMsg}`,
                ind,
            )
            return
        }

        if (canEditMembership && teamMember.accessLevel != role) {
            updateMemberRole(teamMember, role)
            return
        }
    }

    render() {
        const {
            teamMember,
            canViewReport,
            canEditMembership,
            canRemoveMembership,
            isInvitedMember,
            isCurrentUser,
            isTeamOwner,
        } = this.props
        const { id, accessLevel, primaryEmail, fullName } = teamMember
        const name = fullName || ""
        const userName = getDisplayName(
            name,
            toTitleCase(primaryEmail.split("@")[0]),
        )

        return (
            <div className="team-member-row">
                <div className="btn-avatar">
                    <Avatar emailAddress={primaryEmail} name={name} />
                </div>
                <div className="team-member-name">
                    <h4>{userName}</h4>
                    <p>{primaryEmail}</p>
                </div>
                <div className="btn-row">
                    {canViewReport && (
                        <button
                            className="btn btn-default btn-md grey-btn btn-margin team-modal-btn"
                            type="button"
                            onClick={this.viewReport}
                        >
                            View report
                        </button>
                    )}
                    {canEditMembership && accessLevel && (
                        <DropdownButton
                            id={`team-member-role-${id}`}
                            title={accessLevel}
                            bsStyle="default"
                            className="btn btn-default btn-margin team-modal-btn"
                        >
                            <MenuItem
                                disabled={isCurrentUser || isTeamOwner}
                                onClick={() => this.updateRole("Admin")}
                            >
                                Admin
                            </MenuItem>
                            <MenuItem
                                disabled={isCurrentUser || isTeamOwner}
                                onClick={() => this.updateRole("Member")}
                            >
                                Member
                            </MenuItem>
                        </DropdownButton>
                    )}
                    {!canEditMembership && (
                        <span className="team-member-access-level-label">
                            {accessLevel}
                        </span>
                    )}
                    <button
                        disabled={!canRemoveMembership}
                        style={
                            !canRemoveMembership ? { visibility: "hidden" } : {}
                        }
                        className="btn btn-default btn-md random btn-circle-logo"
                        type="button"
                        onClick={this.handleAdminAction}
                    >
                        {isInvitedMember ? (
                            <img src={Circle} alt="Uninvite team member" />
                        ) : (
                            <img src={Archive} alt="Archive team member" />
                        )}
                    </button>
                </div>
            </div>
        )
    }
}

export default TeamMemberRow



// WEBPACK FOOTER //
// ./src/components/team_member_row.jsx